// @ts-nocheck
import { getMemberInfo } from "@store/Framework/Services/Pages/UserSetup/MailChimpEmailService";
import { MailChimpMemberInterestsModel } from "@store/Framework/Types/ApiModels";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type GetMailChimpMemberInfoParameter = {
    email: string;
};

type HandlerType = ApiHandler<GetMailChimpMemberInfoParameter, MailChimpMemberInterestsModel>;

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getMemberInfo(props.parameter.email);
};

export const DispatchCompleteGetMemberInfo: HandlerType = props => {
    const { dispatch, apiResult } = props;
    dispatch({
        type: "Store/Pages/UserSetup/GetMemberInfo",
        memberInfo: apiResult,
    });
};

export const chain = [RequestDataFromApi, DispatchCompleteGetMemberInfo];

const getMailChimpMemberInfo = createHandlerChainRunner(chain, "GetMailChimpMemberInfo");
export default getMailChimpMemberInfo;
